const PIXEL_ID = '1154323073507518'

let initialized = false

export function initMetaPixel() {
  if (initialized) return
  initialized = true

  const w = window as any

  // If fbq already exists (e.g. script already loaded), just ensure init is called
  if (w.fbq) {
    w.fbq('init', PIXEL_ID)
    addNoscriptPixel()
    return
  }

  // Create the fbq stub that queues calls until the real SDK loads
  const n: any = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  }
  w.fbq = n
  w._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  // Load the Facebook SDK script
  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(script)

  // Initialize the pixel
  w.fbq('init', PIXEL_ID)

  // Add noscript fallback
  addNoscriptPixel()
}

function addNoscriptPixel() {
  // Add the noscript tracking pixel image as a fallback
  if (document.getElementById('fb-noscript-pixel')) return
  const noscript = document.createElement('noscript')
  noscript.id = 'fb-noscript-pixel'
  const img = document.createElement('img')
  img.height = 1
  img.width = 1
  img.style.display = 'none'
  img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`
  noscript.appendChild(img)
  document.body.appendChild(noscript)
}

export function trackPageView() {
  const w = window as any
  if (w.fbq) {
    w.fbq('track', 'PageView')
  }
}

export function trackAddToCart() {
  const w = window as any
  if (w.fbq) {
    w.fbq('track', 'AddToCart')
  }
}
